import { css } from 'styled-components';

const SIZES = {
  tablet_large_width: 1024,
  tablet_small_width: 768,
  mobile_large_width: 640,
  mobile_mid_width: 425,
  mobile_small_width: 375,
}

const media = {
  // PC large
  pcLarge: (...args) => css`
    @media only screen and (min-width: ${SIZES.tablet_large_width}px) {
      ${css(...args)}
    }
  `,

  // 태블릿 large
  tabletLarge: (...args) => css`
    @media only screen
      and (max-width: ${SIZES.tablet_large_width - 1}px)
      and (min-width: ${SIZES.tablet_small_width}px) { 
      ${css(...args)}
    }
  `,
  
  // 태블릿 small
  tabletSmall: (...args) => css`
    @media only screen
      and (max-width: ${SIZES.tablet_small_width -1}px)
      and (min-width: ${SIZES.mobile_large_width}px) {
      ${css(...args)}
    }
  `,
  
  // 모바일 large
  mobileLarge: (...args) => css`
    @media only screen
      and (max-width: ${SIZES.mobile_large_width - 1}px)
      and (min-width: ${SIZES.mobile_mid_width}px) {
      ${css(...args)}
    }
  `,
  
  // 모바일 mid
  mobileMid: (...args) => css`
    @media only screen
      and (max-width: ${SIZES.mobile_mid_width - 1}px)
      and (min-width: ${SIZES.mobile_small_width}px) {
      ${css(...args)}
    }
  `,

  // 모바일 small
  mobileSmall: (...args) => css`
    @media only screen and (max-width: ${SIZES.mobile_small_width - 1}px) {
      ${css(...args)}
    }
  `,
};

export default media;
